import intl from 'react-intl-universal';
import cookie from 'js-cookie';
// 是否是正式环境
// const isProduct = window.location.href.includes('fuwu.popmart');

console.log(process.env.UMI_ENV, process.env.APP_ENV);

// 请求地址
let apiHost = 'https://fuwu-api.popmart.com';

let customerApiHost = 'https://customer-api.paquapp.com';

// 国际化不一致，国内和 api Host 一致
let rbacApiHost = 'https://fuwu-api.popmart.com';
let TIANRUNIdentifier = 'popmart';

export const AIHost =
    process.env.NODE_ENV === 'development'
        ? //  ? 'http://172.26.10.88:17191'
          'https://pop-customer-search.paquapp.com'
        : 'https://pop-customer-search.paquapp.com';

// 飞书 appId
// 0: 一线(三方) 1：二线（泡泡）
// const appIds = {
//     prod: { 0: 'cli_a4b7b72a4878d00e', 1: 'cli_a4b7bb5c1c7d5013' },
//     test: { 0: 'cli_a32b35f16cf8900d', 1: 'cli_a32b3a0255f9100c' },
// };
let feishuAppIds: Record<string, string> = {
    0: 'cli_a4b7b72a4878d00e',
    1: 'cli_a4b7bb5c1c7d5013',
};
let APP_SECRET = '';
// 是否是国际化站点
export const isGlobalEnv = !!process.env.APP_ENV;
export const Country = isGlobalEnv
    ? window.location.pathname.replaceAll('/', '')?.toLowerCase() || 'hk'
    : '';

// iframe 地址
// export const iframeUrl = isProduct
//     ? 'https://customerh5.popmart.com/#/searchOrderList'
//     : 'https://customerh5-test.popmart.com/#/searchOrderList';

switch (process.env.UMI_ENV) {
    case 'prod':
        TIANRUNIdentifier = 'popmart';
        APP_SECRET = '9e6e4cab72cf1356114719d22c5c85a5';
        if (!isGlobalEnv) {
            feishuAppIds = {
                0: 'cli_a4b7b72a4878d00e',
                1: 'cli_a4b7bb5c1c7d5013',
            };

            apiHost = 'https://fuwu-api.popmart.com';
            rbacApiHost = 'https://fuwu-api.popmart.com';
            customerApiHost = 'https://customer-api.paquapp.com';
        } else {
            // 国际化环境 没有三方登陆
            feishuAppIds = {
                0: '',
                1: 'cli_a678a71017a8100d',
            };
            apiHost = `https://prod-gss-api.popmart.com/${Country}`;
            customerApiHost = `https://prod-gss-api.popmart.com/${Country}/customer-api`;
            rbacApiHost = `https://prod-gss-api.popmart.com/${Country}/rbac-api`;
        }
        break;
    case 'test':
    case 'dev':
        TIANRUNIdentifier = 'paopaomate1';

        APP_SECRET = '6c5978f9bc3a8f7e62b4a0671c6ec320';
        if (!isGlobalEnv) {
            feishuAppIds = {
                0: 'cli_a32b35f16cf8900d',
                1: 'cli_a32b3a0255f9100c',
            };

            apiHost = 'https://fuwu-api-test.popmart.com';
            rbacApiHost = 'https://fuwu-api-test.popmart.com';
            customerApiHost = 'https://customer-test.paquapp.com';
        } else {
            // 国际化环境 没有三方登陆
            feishuAppIds = {
                0: '',
                1: 'cli_a67a70650d6c500d',
            };
            apiHost = `https://beta-gss-api.popmart.com/${Country}`;
            customerApiHost = `https://beta-gss-api.popmart.com/${Country}/customer-api`;
            rbacApiHost = `https://beta-gss-api.popmart.com/${Country}/rbac-api`;
        }
        break;
    case 'stage':
        // 国际化暂时没有预发环境
        TIANRUNIdentifier = 'popmart';
        feishuAppIds = { 0: 'cli_a4b7b72a4878d00e', 1: 'cli_a4b7bb5c1c7d5013' };
        apiHost = 'https://fuwu-stage-api.popmart.com';
        rbacApiHost = 'https://fuwu-stage-api.popmart.com';
        customerApiHost = 'https://customer-stage-api.paquapp.com';
        APP_SECRET = '9e6e4cab72cf1356114719d22c5c85a5';
        break;
}

export const currentLang = cookie.get('lang') || 'zh-CN';
export const langTransition = {
    'zh-CN': 'zh-hans',
    'en-US': 'en',
};

export {
    feishuAppIds,
    apiHost,
    customerApiHost,
    APP_SECRET,
    rbacApiHost,
    TIANRUNIdentifier,
};

// 公司
export const companyValues = () => {
    const company = ['POPMART', intl.get('泡泡玛特文化创意有限公司')];
    return Object.values(feishuAppIds).reduce((values, current, index) => {
        values[current] = company[index];
        return values;
    }, {});
};

// 文件CDN域名
export const fileCDN = isGlobalEnv
    ? 'https://gss-work-order-gcs.popmart.com'
    : 'https://service-center.popmart.com';
